import { useState } from "react";

interface VideoDemoProps {
  poster: string;
  title: string;
}

export default function VideoDemo({ poster, title }: VideoDemoProps) {
  const [started, setStarted] = useState(false);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
        <i className="ri-play-circle-line text-primary-500"></i>
        预告视频
      </h2>
      <div className="relative mt-4 aspect-video w-full overflow-hidden rounded-lg bg-primary-950">
        <img
          src={poster}
          alt={`${title} 预告封面`}
          title={`${title} 预告视频`}
          className={`h-full w-full object-top ${started ? "opacity-30" : "opacity-70"}`}
        />
        {!started ? (
          <button
            type="button"
            onClick={() => setStarted(true)}
            aria-label="播放预告视频"
            className="absolute inset-0 flex flex-col items-center justify-center gap-3"
          >
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-500 text-background-50 transition-transform hover:scale-110">
              <i className="ri-play-fill text-3xl"></i>
            </span>
            <span className="text-sm text-background-100">点击播放预告片</span>
          </button>
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center">
            <i className="ri-loader-4-line animate-spin text-3xl text-accent-400"></i>
            <p className="text-sm text-background-100">
              预告视频加载功能演示中
            </p>
            <p className="text-xs text-background-400">
              本页为演示站点，暂无可播放的真实视频内容
            </p>
            <button
              type="button"
              onClick={() => setStarted(false)}
              className="mt-2 inline-flex items-center gap-1 rounded-md border border-background-50/40 px-3 py-1.5 text-xs text-background-100 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-refresh-line"></i>
              重置演示
            </button>
          </div>
        )}
      </div>
    </div>
  );
}